import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import studentAuthService from "../../services/studentAuthService";

export default function StudentForgotPassword() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();

    setLoading(true);
    setError("");

    try {
      await studentAuthService.forgotPassword({
        email: email.trim(),
      });

      navigate("/student/forgot-password", {
        replace: true,
        state: {
          email: email.trim(),
        },
      });
    } catch (err) {
      setError(
        err.friendlyMessage ||
          err.response?.data?.message ||
          "Could not process your request."
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="pm-auth-shell">
      <motion.div
        className="pm-auth-card"
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <Link
          to="/student/login"
          className="pm-btn pm-btn--ghost pm-btn--sm"
          style={{ marginBottom: 20 }}
        >
          ← Back to login
        </Link>

        <Link to="/" className="pm-auth-brand">
          <span className="pm-nav__mark">PM</span> Positive Moves
        </Link>

        <h1>Forgot password?</h1>

        <p className="pm-auth-sub">
          Enter your registered email address and we'll send you
          instructions to reset your password.
        </p>

        <form onSubmit={handleSubmit} className="pm-auth-form">
          <div className="pm-field">
            <label>Email address</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@college.edu" />
          </div>
          {error && (<div className="pm-form-error">{error}</div>)}

          <button className="pm-btn pm-btn--primary pm-btn--lg" disabled={loading} type="submit">
            {loading ? "Sending…" : "Send"}
          </button>
        </form>

        <p className="pm-auth-switch">
          Remember your password?{" "}
          <Link to="/student/login">Log in</Link>
        </p>
      </motion.div>
    </div>
  );
}